




















import { Component, Vue } from 'vue-property-decorator';
import PostJournalComponent from './components/PostJournalComponent.vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import moment from 'moment';
import axios from 'axios';
import noNb from 'ant-design-vue/lib/locale-provider/nb_NO';
import svSE from 'ant-design-vue/lib/locale-provider/sv_SE';
import enUS from 'ant-design-vue/lib/locale-provider/en_US';
import { i18n, resolveLocale } from '@/i18n';
import { ActaService } from './services/ActaService';
import { lazyInject } from './ioc/DIContainer';
import { TYPES } from './ioc/Types';

// import en_US from 'ant-design-vue/lib/locale-provider/en_US';
Vue.config.productionTip = false;

Vue.use(Antd);

@Component({
  components: {
    PostJournalComponent
  }
})
export default class App extends Vue {
  @lazyInject(TYPES.ActaService)
  private actaService!: ActaService;

  tenantId: string = '';
  tenantName: string = '';
  isValid: boolean = false;
  selectedLocale:any = noNb;

  created () {
    if (this.$route.query.id) {
      this.tenantId = this.$route.query.id.toString();
    }
    let locale = resolveLocale(window.navigator.language);
    this.selectedLocale = locale === 'no' || locale === 'nb' ? noNb : enUS;
    if (this.tenantId !== undefined) {
      moment.locale(window.navigator.language);
      this.actaService.getTenantNameBySSoId(this.tenantId, this.dataFetched, this.fetchError);
    }
  }

  dataFetched (response: any) {
    this.tenantName = response.data.ResponseValue;
    this.isValid = true;
  }

  fetchError () {
    this.$notification['error']({
      message: 'Error',
      description: 'Error occurred',
      duration: 5
    });
  }
}
